/**
 * Analytics
 * Analytics API
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = Raw, 1 = Device, 2 = MeshHealth
 */
export enum TelemetryAggregationMode {
    Raw = 'Raw',
    Device = 'Device',
    MeshHealth = 'MeshHealth'
}

